import { UserAddOutlined, PlusOutlined, CaretLeftOutlined } from '@ant-design/icons';
import { Steps, Button, Tooltip } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Wrap from './styles';

type Props = {
  currentStep: number;
  backStepPrevious: () => void;
  nextStep: () => void;
};
const HeaderRegister: FC<Props> = ({ nextStep, currentStep, backStepPrevious }) => {
  const { Step } = Steps;
  const [title, setTitle] = useState<string>('1. 患者情報登録');
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    setCurrent(currentStep);
    switch (currentStep) {
      case 0:
        setTitle('1. 患者情報登録');
        break;
      case 1:
        setTitle('2. CPAP指示書登録');
        break;
      case 2:
        setTitle('3. 登録内容の確認');
        break;
      case 3:
        setTitle('4. 登録完了');
        break;
    }
  }, [currentStep]);

  return (
    <Wrap>
      <div className="header1">
        <div>
          <UserAddOutlined className="icon1" />
          <p className="extraLargeFont inline">新規患者登録</p>
        </div>
        <div>
          <Steps size="small" type="navigation" current={current} className="site-navigation-steps">
            <Step title="患者情報登録" />
            <Step title="CPAP指示書登録" />
            <Step title="登録内容の確認" />
            <Step className="last" title="登録完了" />
          </Steps>
        </div>
        {currentStep === 1 || currentStep === 2 ? (
          <Button onClick={backStepPrevious} className="pl-0 btnBack">
            <CaretLeftOutlined />
            {currentStep === 2 ? 'CPAP指示書登録に戻る' : '患者登録に戻る'}
          </Button>
        ) : (
          ''
        )}
      </div>
      <div className="header2 extraLargeFont">
        {title}
        {current === 0 ? (
          <Tooltip className="pts-right" color="#FFF8DD" placement="bottomRight" title="医療機関の新規登録はこちら">
            <Link to="/medical_institution/register">
              <Button className="plus" icon={<PlusOutlined />} />
            </Link>
          </Tooltip>
        ) : (
          ''
        )}
      </div>
    </Wrap>
  );
};

export default HeaderRegister;
